/**
 * Starts a tracked mutation whose state already shows how it ended (a footer error, a
 * toast): its rejection has no other reader, so it is not left unhandled.
 */
export function startMutation<Request>(
  mutation: { track: (request: Request) => Promise<unknown> },
  request: Request
): void {
  mutation.track(request).catch(() => undefined);
}
